import { Button } from "antd";
import { MineralMap } from "./map/index";
import { useTranslation } from "react-i18next";
import { Dinamictable } from "./dinamictable/index";
import { DinamicByRegions } from "./dinamicbyregions/index";
import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import { useGetFertilizerDataQuery, useGetFertilizerwarehouseDataQuery, useGetFertilizerOnMapQuery } from "./api";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { useState, useCallback } from "react";
import style from "./style.module.css";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import { PlusOutlined } from "@ant-design/icons";
import { useReportCompanyWarehousesMutation } from "../../../redux/api/chemicalization/companyWarehousesApi";
import ReportCompanyWarehousesModal from "../../../pages/admin/chemicalization/companyWarehouses/ReportСompanyWarehousesModal";

export const Mineralfertilizersuppliers = () => {
  const { t } = useTranslation();
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [selectedRegionId, setSelectedRegionId] = useState<number | null>(null);
  const [selectedRegionName, setSelectedRegionName] = useState<string>("");
  const [ showReportModal, setShowReportModal ] = useState<boolean>(false);
  const [ getReportСompanyWarehouses ] = useReportCompanyWarehousesMutation();
  const openReportModal = () => {
    setShowReportModal(true);
    };
    const getReport = async (payload: { year: number; language: string  }): Promise<Blob> => {
      return await getReportСompanyWarehouses(payload).unwrap();
      };
  const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(new EntTerritorialUnitsFilter({ page: 1, size: 15 }));
  const { data: fertilizersData, isLoading: isLoadingFertilizers } = useGetFertilizerDataQuery({
    year: selectedYear ? selectedYear.toString() : undefined,
    regionId: selectedRegionId
  });

  const { data: fertilizersOnMapData, isLoading: isLoadingFertilizersOnMap } = useGetFertilizerOnMapQuery({
    year: selectedYear ? selectedYear.toString() : undefined,
    regionId: selectedRegionId
  });
  const { data: fertilizersWarehouseData, isLoading: isLoadingFertilizersWarehouse } = useGetFertilizerwarehouseDataQuery({
    year: selectedYear ? selectedYear.toString() : undefined
  });

  const handleRegionClick = useCallback((regionId: number, regionName: string) => {
    setSelectedRegionId(regionId);
    setSelectedRegionName(regionName);
  }, []);

  const handleResetRegion = () => {
    setSelectedRegionId(null);
    setSelectedRegionName("");
  };
  const isLoading = isLoadingFertilizers || isLoadingFertilizersOnMap || isLoadingFertilizersWarehouse || polygonsLoading;
  
  if (isLoading) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <PreloaderSvg />
        </div>
    );
}

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.title}>
          <div className={style.title_header}>
            <h1>{t('Suppliers of mineral fertilizers')}</h1>
            <Button style={ { marginLeft: '5px' } } type="primary" icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
			  onClick={ () => openReportModal() }>
		{ t('reports.report_by_company_warehouses') }
	  </Button>
    <ReportCompanyWarehousesModal
		getReport={getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
          </div>
          <div className={style.title_inner}>
            <img src="./homeicon.svg" alt="home" />
            <p>{t('Home')}</p>
            <img src="./arrowright.svg" alt="arrow" />
            <p>{t('Mineral fertilizers')}</p>
            <img src="./arrowright.svg" alt="arrow" />
            <span className={style.namepage}>{t('Suppliers of mineral fertilizers')}</span>
          </div>
        </div>

        <div className={style.mapcontainer}>
          <MineralMap
            latitude={41.5089324}
            longitude={74.2384768}
            polygonsData={polygonsData}
            selectedYear={selectedYear}
            onYearChange={setSelectedYear}
            fertilizersData={fertilizersData}
            fertilizersOnMapData={fertilizersOnMapData}
            isLoadingFertilizersOnMap={isLoadingFertilizersOnMap}
            isLoadingFertilizers={isLoadingFertilizers}
            onRegionClick={handleRegionClick}
            onResetRegion={handleResetRegion}
            selectedRegionName={selectedRegionName}
          />
        </div>
        <div className={style.content_inner}>
          <Dinamictable
            fertilizersWarehouseData={fertilizersWarehouseData}
            selectedYear={selectedYear}
            onYearChange={setSelectedYear}
          />
          <div className={style.content_inner_body}>
            <DinamicByRegions
              fertilizersWarehouseData={fertilizersWarehouseData}
              selectedYear={selectedYear}
              onYearChange={setSelectedYear}
            />
          </div>
        </div>
      </div>
    </div>
  );
};